// Central page registry: per-language slugs for every static page.
// Used for routing, header/footer nav, breadcrumbs, hreflang and sitemap generation.
// English is the default language (no prefix). French => /fr/... German => /de/...

export const LANG_PREFIX = { en: "", fr: "/fr", de: "/de" };

// key: { en, fr, de } slugs (no leading slash). "" = language home.
export const PAGE_SLUGS = {
  home: { en: "", fr: "", de: "" },
  dentalTreatment: {
    en: "dental-treatment-vietnam",
    fr: "soins-dentaires-vietnam",
    de: "zahnbehandlung-vietnam",
  },
  prices: {
    en: "dental-prices-vietnam",
    fr: "prix-soins-dentaires-vietnam",
    de: "zahnbehandlung-vietnam-kosten",
  },
  clinics: {
    en: "dental-clinics-vietnam",
    fr: "cliniques-dentaires-vietnam",
    de: "zahnkliniken-vietnam",
  },
  dentalTourism: {
    en: "dental-tourism-vietnam",
    fr: "tourisme-dentaire-vietnam",
    de: "zahntourismus-vietnam",
  },
  patientGuide: {
    en: "patient-guide",
    fr: "guide-du-patient",
    de: "patientenratgeber",
  },
  beforeAfter: { en: "before-after", fr: "avant-apres", de: "vorher-nachher" },
  faq: { en: "faq", fr: "faq", de: "faq" },
  blog: { en: "blog", fr: "blog", de: "blog" },
  about: { en: "about", fr: "a-propos", de: "ueber-uns" },
  contact: { en: "contact", fr: "contact", de: "kontakt" },
  howWeSelect: {
    en: "how-we-select-providers",
    fr: "comment-nous-selectionnons-les-prestataires",
    de: "wie-wir-anbieter-auswaehlen",
  },
  editorial: {
    en: "editorial-policy",
    fr: "politique-editoriale",
    de: "redaktionsrichtlinie",
  },
  medicalReview: {
    en: "medical-review-policy",
    fr: "politique-de-revision-medicale",
    de: "richtlinie-medizinische-pruefung",
  },
  disclaimer: {
    en: "treatment-information-disclaimer",
    fr: "avertissement-informations-traitement",
    de: "hinweis-behandlungsinformationen",
  },
  privacy: {
    en: "privacy-policy",
    fr: "politique-de-confidentialite",
    de: "datenschutzerklaerung",
  },
  terms: { en: "terms", fr: "conditions-generales", de: "agb" },
};

// Build an absolute in-app path (starts with "/") for a static page key + lang.
export function pagePath(key, lang = "en") {
  const prefix = LANG_PREFIX[lang] ?? "";
  const slug = (PAGE_SLUGS[key] && PAGE_SLUGS[key][lang]) ?? PAGE_SLUGS[key]?.en ?? "";
  if (!slug) return prefix || "/"; // home
  return `${prefix}/${slug}`;
}

// Build path for a dynamic entity (treatment / location / article) given its slug map.
export function entityPath(basePathKey, slugMap, lang = "en") {
  // basePathKey unused for now; entities live at root level per SEO spec.
  const prefix = LANG_PREFIX[lang] ?? "";
  const slug = slugMap[lang] ?? slugMap.en;
  return `${prefix}/${slug}`;
}

// Article path lives under /blog/<slug>
export function articlePath(slugMap, lang = "en") {
  const prefix = LANG_PREFIX[lang] ?? "";
  const blogSlug = PAGE_SLUGS.blog[lang] ?? "blog";
  const slug = slugMap[lang] ?? slugMap.en;
  return `${prefix}/${blogSlug}/${slug}`;
}
